import DashboardLayout from "../../layouts/dashboard/DashboardLayout.vue";
// import Profile from "./views/Profile";
import Auth from "../../router/middleware/Auth";
// import profileConfirm from "./components/ProfileConfirm";
// import ResponseCard from "./components/ResponseCard.vue";
// import RefereeFormReport from "./components/RefereeFormReport.vue";
import FirmProfile from "./views/FirmProfile.vue";
import FirmCard from "./views/FirmCard.vue";

export default [
  {
    path: "/firm",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "firm",
        components: { view: FirmProfile },
        meta: { middleware: [Auth], breadcrumb: "Dashboard" },
      },
      {
        path: "firm-card/:firmCode?/:application?",
        name: "firm-card",
        components: { view: FirmCard },
        meta: { middleware: [Auth], breadcrumb: "New Firm Application" },
      },
      // {
      //   path: "profileConfirm",
      //   name: "profileConfirm",
      //   components: { view: profileConfirm },
      //   meta: { middleware: [Auth] },
      // },
      // {
      //   path: "response/:user?/:code?",
      //   name: "ResponseCard",
      //   components: { view: ResponseCard },
      //   meta: {
      //     middleware: [Auth],
      //     breadcrumb: "Dashboard",
      //   },
      // },
      // {
      //   path: "RefereeFormReport/:entryNo",
      //   name: "RefereeFormReport",
      //   components: { view: RefereeFormReport },
      //   meta: {
      //     middleware: [Auth],
      //     breadcrumb: "Dashboard",
      //   },
      // },
    ],
  },
];
